import { common } from "./routes/common"
import { profile } from "./routes/profile"
import { products } from "./routes/products"
import { cart } from "./routes/cart"
import { checkout } from "./routes/checkout"
import { invoice } from "./routes/invoice"
import { KP_POLICY_STATIC } from "@/static/kpPolicy"
import { AGREEMENT_CLIENT_STATIC } from "@/static/kpAgreementClient"
import { AcDocs } from "@academy/components"

const routes = [
  ...common,
  ...profile,
  ...products,
  ...cart,
  ...checkout,
  ...invoice,
  {
    path: "/privacy-policy",
    name: "privacyPolicy",
    meta: { requiresAuth: false, layout: "Docs", title: "Privacy Policy" },
    props: {
      pageTitle: "policy-window.privacy-policy",
      contentStatic: KP_POLICY_STATIC,
    },
    component: AcDocs,
  },
  {
    path: "/agreement",
    name: "agreement",
    meta: {
      requiresAuth: false,
      layout: "Docs",
      title: "User Agreement & Terms",
    },
    props: {
      pageTitle: "agreement.title",
      tabletTitle: "agreement.tabletTitle",
      mobileTitle: "agreement.tabletTitle",
      contentStatic: AGREEMENT_CLIENT_STATIC,
      showContentList: true,
      tabletTitleClasses: [
        "[&_h2]:max-[1024px]:text-[32px]",
        "[&_h2]:max-[767px]:text-[26px]",
        "[&_h2]:max-[767px]:leading-[28px]",
        "max-[767px]:!p-[24px]",
      ],
    },
    component: AcDocs,
  },
  {
    path: "/investment-deck-frame",
    name: "investmentDeckFrame",
    meta: {
      requiresAuth: false,
      layout: "Frame",
      title: "Investment Deck",
    },
    component: () => import("views/InvestmentDeckPage/InvestmentDeckPage.vue"),
  },
  {
    path: "/about-frame",
    name: "aboutFrame",
    meta: { requiresAuth: false, layout: "Frame", title: "About Us" },
    component: () => import("views/AboutPage/AboutPage.vue"),
  },
]

export { routes }
